module.exports = __webpack_public_path__ + "static/media/gerrys-grill.7a187a29.jpg";